import React from 'react';

const DownArrow = () => 
<svg xmlns="http://www.w3.org/2000/svg" width="16.264" height="22.901" viewBox="0 0 16.264 22.901"><g transform="translate(-1543.502 -549.556)"><line y1="20.351" transform="translate(1551.658 549.556)" fill="none" stroke="#f78d1e" strokeMiterlimit="10" strokeWidth="3"/><path d="M3780.793,564.355l-7.46,6.127-6.852-6.127" transform="translate(-2221.979)" fill="none" stroke="#f78d1e" strokeMiterlimit="10" strokeWidth="3"/></g></svg>
;

export default DownArrow;